import { create } from 'zustand';

const STORAGE_KEY = 'mlm.member.activeSlotId';

/**
 * Phase 13: the active slot context. Persists across reloads via localStorage.
 * Pre-slot members have `activeSlotId === null`.
 *
 * The store is hydrated on App boot by `useMySlots` once the slots query lands:
 * if the persisted id is no longer one of the caller's active slots (deleted,
 * never owned) we fall back to the earliest active slot.
 */
type State = {
  activeSlotId: string | null;
  setActiveSlotId: (id: string | null) => void;
  clear: () => void;
};

function readStored(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function writeStored(value: string | null) {
  if (typeof window === 'undefined') return;
  try {
    if (value) window.localStorage.setItem(STORAGE_KEY, value);
    else window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore quota / private-mode */
  }
}

export const useActiveSlotStore = create<State>((set) => ({
  activeSlotId: readStored(),
  setActiveSlotId: (id) => {
    writeStored(id);
    set({ activeSlotId: id });
  },
  clear: () => {
    writeStored(null);
    set({ activeSlotId: null });
  },
}));
